module.exports = __webpack_public_path__ + "img/P150T_weapon_98.1c9f25f3.png";